import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalises a serial number for routing + lookup. Trim + uppercase: the
 * format-pattern check on the server runs against the same shape. Spaces in
 * the middle of a scanned serial are an OCR/keyboard artefact and get
 * collapsed — the format pattern itself never contains whitespace.
 */
export function normalizeSerial(input: string): string {
  return input.trim().replace(/\s+/g, "").toUpperCase();
}
